import { differenceInYears } from 'date-fns';

export const dateInvalid = (date: unknown) => {
	if (!(date instanceof Date) || isNaN(date.getTime())) {
		return true;
	}
	return false;
};

export const formatDateForValidation = (date: Date | null) => {
	// don't use the date-fns function since it is an expensive call.
	if (dateInvalid(date)) {
		throw new Error('formatDateForValidation() received invalid date.');
	}

	const dateParam = date as Date;
	const dateComponents = dateParam.toISOString().substring(0, 10).split('-');

	const monthString = dateComponents[1];
	const dayString = dateComponents[2];
	const yearString = dateComponents[0];

	return [monthString, dayString, yearString].join('-');
};

export const calculateAge = (dateOfBirth: Date, referenceDate: Date = new Date()) => {
	return differenceInYears(referenceDate, dateOfBirth);
};
